var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10608 13.967C7.62486 13.967 8.85608 12.7358 8.85608 11.217C8.85608 9.69826 7.62486 8.46704 6.10608 8.46704C4.5873 8.46704 3.35608 9.69826 3.35608 11.217C3.35608 12.7358 4.5873 13.967 6.10608 13.967Z",
    stroke: "currentColor",
    strokeWidth: 1.38209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7311 20.1545C17.2499 20.1545 18.4811 18.9233 18.4811 17.4045C18.4811 15.8858 17.2499 14.6545 15.7311 14.6545C14.2123 14.6545 12.9811 15.8858 12.9811 17.4045C12.9811 18.9233 14.2123 20.1545 15.7311 20.1545Z",
    stroke: "currentColor",
    strokeWidth: 1.38209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7311 7.77954C17.2499 7.77954 18.4811 6.54832 18.4811 5.02954C18.4811 3.51076 17.2499 2.27954 15.7311 2.27954C14.2123 2.27954 12.9811 3.51076 12.9811 5.02954C12.9811 6.54832 14.2123 7.77954 15.7311 7.77954Z",
    stroke: "currentColor",
    strokeWidth: 1.38209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4194 6.51636L8.41785 9.73042",
    stroke: "currentColor",
    strokeWidth: 1.38209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41785 12.7039L13.4194 15.9179",
    stroke: "currentColor",
    strokeWidth: 1.38209,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7f0f7366ac59e94c81d4c1719119455a.svg";
export { ForwardRef as ReactComponent };